<template>
  <div class="extended-settings">
    <LButton
      :block="isMobile"
      :color="isExtended ? 'primary' : 'secondary'"
      prepend-icon="lnx-edit"
      :append-icon="isExtended ? 'lnx-arrow_up' : 'lnx-arrow_down'"
      @click="onToggleExtendedSettings"
    >
      {{ text }}
    </LButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { LButton } from '@wgg.hyve/hyve-ui-library'
import { useFormStore } from '@/stores/formStore.ts'
import { useBreakpoint } from '@/composables'

const { toggleExtendedSettings } = useFormStore()
const { isMobile } = useBreakpoint()
const isExtended = ref(false)

type Props = {
  text?: string
}

const props = defineProps<Props>()

function onToggleExtendedSettings() {
  isExtended.value = !isExtended.value
  toggleExtendedSettings()
}
</script>
